var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-a-buttons",class:{'flex-wrap': !_vm.nowrap}},_vm._l((_vm.items),function(btn,index){return _c('vs-button',{key:`${btn}_${index}`,staticClass:"px-3 py-1",class:{
                'px-5': typeof btn === 'string',
                'py-2': typeof btn === 'string',
                'active': _vm.selectButton === btn
             },staticStyle:{"box-shadow":"none","background-color":"transparent"},style:({
               color: _vm.selectButton === btn ? '#7E72F2' : '#696D71',
               fontWeight: _vm.selectButton === btn ? 600 : 400,
               borderColor: _vm.selectButton === btn ? '#7E72F2' : '#696D71',
             }),attrs:{"color":"#CDCDCD","type":"border"},on:{"click":function($event){return _vm.onClickButton(btn)}}},[_c('div',[(btn.feather)?_c('feather-icon',{staticClass:"mt-1",staticStyle:{"width":"18px","height":"18px"},attrs:{"icon":btn.feather}}):_c('span',[_vm._v(_vm._s(btn))])],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }